import * as React from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import AuthAction from "../../stores/Auth/AuthAction";
import { connect } from "react-redux";
import InputAdornment from "@mui/material/InputAdornment";
import PersonIcon from "@mui/icons-material/Person";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LockIcon from "@mui/icons-material/Lock";
import "./signin.css";
import logo from "../../components/logo/influencerLogo.png";
import { Grid, useTheme } from "@mui/material";
import MuiButton from "../../components/muiButton/MuiButton";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router";
import { createBrowserHistory } from "history";

const mapStateToProps = (state, ownProps) => ({
  isRequesting: selectRequesting(state, [AuthAction.REQUEST_LOGIN]),
});

function SignIn(props) {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = React.useState(false);
  const history = createBrowserHistory();
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const validationSchema = yup.object().shape({
    email: yup.string().trim().required("Email/UserName is required"),
    password: yup.string().trim().required("Password is required"),
  });

  let initial = {};

  initial = {
    email: "",
    password: "",
  };

  const textFieldForUsernameRef = React.useRef(null);
  const textFieldForPasswordRef = React.useRef(null);
  const buttonForLoginRef = React.useRef(null);

  return (
    <Box className="loginPageContainer">
      <Formik
        initialValues={initial}
        validationSchema={validationSchema}
        onSubmit={(values, formikHelpers) => {
          const callBackFunction = () => {
            if (
              location.state.from !== "/logout" &&
              location.state.from !== "/"
            ) {
              navigate(location.state.from, {
                state: { from: location.pathname },
              });
            } else navigate("/influencerDashboard");
          };

          props.dispatch(
            AuthAction.requestLogin(
              values.email,
              values.password,
              callBackFunction
            )
          );
        }}
      >
        {({ values, errors, isValid, touched, dirty, handleChange }) => (
          <Form>
            <Grid container position={"fixed"} p={5}>
              <img
                src={logo}
                className="logoContainer"
                style={{
                  aspectRatio: "4:2",
                }}
                alt="logo"
              />
            </Grid>
            <Box>
              <Grid
                lg={12}
                md={12}
                sm={12}
                container
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                alignSelf={"center"}
                minHeight={"110vh"}
              >
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={12}
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  alignSelf={"center"}
                  position="fixed"
                  width={"549px"}
                  height="fit-content"
                  // className="bg-warning"
                >
                  <Grid
                    className="login-box"
                    // sx={{ opacity: "0.8" }}
                    // onSubmit={handleSubmit}
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                    alignSelf={"center"}
                    bgcolor="white"
                  >
                    <Grid
                      display={"flex"}
                      justifyContent={"flex-end"}
                      alignItems="flex-end"
                      mb={1}
                    >
                      <span
                        className="signin-header"
                        style={{
                          fontFamily: theme.typography.fontFamily,
                          fontSize: "16px",
                        }}
                      >
                        Sign in to your Account
                      </span>
                    </Grid>
                    <Grid
                    // className="bg-warning"
                    >
                      {/* ************************************************************************* userName */}
                      <Field
                        // className="bg-warning"
                        id="email"
                        as={TextField}
                        name="email"
                        autoComplete="email"
                        placeholder="User Name"
                        inputRef={textFieldForUsernameRef}
                        error={Boolean(errors.email) && Boolean(touched.email)}
                        helperText={Boolean(touched.email) && errors.email}
                        autoFocus
                        sx={{
                          border: `1px ${theme.palette.primary.main}`,
                          borderRadius:
                            theme.palette.buttonComponent.borderRadius.small,
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                          "& .MuiOutlinedInput-root": {
                            height: "38px",
                            "&.Mui-focused fieldset": {
                              border: `1.5px solid ${theme.palette.primary.main}`,
                            },
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PersonIcon />
                            </InputAdornment>
                          ),
                          onKeyPress: (event) => {
                            const { key } = event;
                            if (key === "Enter") {
                              textFieldForPasswordRef.current.focus();
                            }
                          },
                        }}
                        fullWidth
                      />
                      <br />
                      <br />
                      {/* ************************************************************************* Password */}
                      <Field
                        name="password"
                        as={TextField}
                        type={showPassword ? "text" : "password"}
                        id="password"
                        inputRef={textFieldForPasswordRef}
                        placeholder="Password"
                        autoComplete="current-password"
                        error={
                          Boolean(errors.password) && Boolean(touched.password)
                        }
                        helperText={
                          Boolean(touched.password) && errors.password
                        }
                        sx={{
                          border: `1px ${theme.palette.primary.main}`,
                          borderRadius:
                            theme.palette.buttonComponent.borderRadius.small,
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                          "& .MuiOutlinedInput-root": {
                            height: "38px",
                            "&.Mui-focused fieldset": {
                              border: `1.5px solid ${theme.palette.primary.main}`,
                            },
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockIcon />
                            </InputAdornment>
                          ),

                          onKeyPress: (event) => {
                            const { key } = event;
                            if (key === "Enter") {
                              buttonForLoginRef.current.click();
                            }
                          },

                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                      />
                      <Typography
                        mt={0.5}
                        mb={2}
                        //  className="bg-warning"
                        textAlign="right"
                      >
                        forgot password?
                      </Typography>
                      {/* ************************************************************************* Submit */}

                      <MuiButton
                        className="submit-btn"
                        type="submit"
                        name={"Login"}
                        width={"100%"}
                        buttonRef={buttonForLoginRef}
                      />
                      <br />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm container>
                    <Grid item xs={12} container>
                      <Grid
                        item
                        xs={12}
                        pr={"1%"}
                        pl={"1%"}
                        pt={2}
                        container
                        direction="row"
                        justifyContent="space-around"
                        alignItems="center"
                        alignSelf={"center"}
                      >
                        <Typography
                          sx={{
                            color: "#797676!important",
                            fontSize: theme.typography.fontSize,
                          }}
                        >
                          ©Ai Influencer 2024 - All Right Reserved.
                        </Typography>
                        <Typography
                          sx={{
                            color: "#797676!important",
                            fontSize: theme.typography.fontSize,
                          }}
                        >
                          Privacy
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
export default connect(mapStateToProps)(SignIn);
